import {
  ArrowLeftOutlined,
  EnvironmentOutlined,
  StarFilled,
  StarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar } from "antd";
import { Input, List, Popup } from "antd-mobile";
import style from "css/hotdesking.module.css";
import React from "react";
import { useTranslation } from "react-i18next";

function SearchUser({
  isOpen,
  onClose,
  list,
  onShowBook,
  onAddFavorite,
  onCancelFavorite,
  onSearch,
  text,
  setText,
}) {
  const { t } = useTranslation();
  return (
    <Popup
      className={`${style.popup} ${style.user}`}
      visible={isOpen}
      onMaskClick={onClose}
    >
      <section className={style.popup_wrapper}>
        <section className={style.popup_container}>
          <section className={style.popup_header}>
            <ArrowLeftOutlined
              className={style.header_icon}
              onClick={onClose}
            />
            <Input
              className={style.header_input}
              placeholder={t("HOTDESKING.MENU.TEAM.BUTTON.SEARCH")}
              value={text}
              onChange={(text) => setText(text)}
              onEnterPress={onSearch}
            />
          </section>
          <section className={style.popup_content}>
            <section className={style.popup_content_list}>
              {list.length > 0 && (
                <List className={style.popup_list}>
                  {list.map((item, idx) => (
                    <List.Item
                      className={style.popup_list_item_wrap}
                      key={idx}
                      onClick={() => {
                        if (item.resource !== undefined) {
                          onShowBook(
                            {
                              ...item,
                              member: {
                                department: item.department,
                                id: item.id,
                                name: item.name,
                                role: item.role,
                              },
                            },
                            item.resource
                          );
                        }
                      }}
                      arrowIcon={false}
                    >
                      <section className={style.popup_list_item}>
                        <section className={style.user_info_section}>
                          <Avatar
                            className={style.user_avatar}
                            icon={
                              <UserOutlined
                                className={style.user_avatar_icon}
                              />
                            }
                          />
                          <article className={style.user_info_article}>
                            <p className={style.user_name}>{item.name}</p>
                            <div className={style.user_department}>
                              <p>{item.role}</p>
                              <span className={style.driver} />
                              <p>{item.department.name}</p>
                            </div>
                            <div
                              className={
                                item.resource === undefined
                                  ? style.user_location
                                  : `${style.user_location} ${style.inuse}`
                              }
                            >
                              <EnvironmentOutlined
                                className={style.location_icon}
                              />
                              {item.resource === undefined ? (
                                <p className={style.location_title}>
                                  No Workplace
                                </p>
                              ) : (
                                <>
                                  <p className={style.location_title}>
                                    {item.resource.location.title}
                                  </p>
                                  <p className={style.location_title}>
                                    {item.resource.title}
                                  </p>
                                </>
                              )}
                            </div>
                          </article>
                        </section>

                        {item.favorite ? (
                          <StarFilled
                            className={`${style.favorite_icon} ${style.fill}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              onCancelFavorite(item.id);
                            }}
                          />
                        ) : (
                          <StarOutlined
                            className={style.favorite_icon}
                            onClick={(e) => {
                              e.stopPropagation();
                              onAddFavorite(item.id);
                            }}
                          />
                        )}
                      </section>
                    </List.Item>
                  ))}
                </List>
              )}
            </section>
          </section>
        </section>
      </section>
    </Popup>
  );
}

export default SearchUser;
